<template>
  <section class="recommend-hospital">
    <header>
      <div>
        <h3>推荐机构</h3>
        <span>7500家医院授权</span>
      </div>
      <button class="more" @click="goToPage">
        <span>更多机构</span>
        <svg-icon :name="'icon_arrow_rig'+(channel=='002_11_0000_0000_00'?'_zx':'')"></svg-icon>
      </button>
    </header>
    <div class="content">
      <div class="name-wrapper">
        <img class="avatar" :src="orgInfo.small_pic_url" />
        <div class="name">
          <h3>{{ orgInfo.name }}</h3>
          <p class="label">
            <template v-if="orgInfo.data_flag === 'old'">
              <Tag content="离我最近" :isActive="true" />
              <Tag v-if="orgInfo.level_name" :content="orgInfo.level_name" />
            </template>
            <template v-else>
              <Tag
                v-if="orgInfo.policy"
                :content="orgInfo.policy"
                :isActive="true"
              />
              <Tag v-if="orgInfo.tag" :content="orgInfo.tag" />
            </template>
          </p>
        </div>
      </div>
      <footer>
        <div class="price-wrapper">
          <span v-if="orgInfo.lowest_price !== undefined" class="price">{{
            formatPrice(orgInfo.lowest_price)
          }}</span>
          <span v-else class="price">{{ formatPrice(orgInfo.min_price) }}</span>
          <span>元/起</span>
        </div>
        <button class="submit" @click="goToBooking">立即预约</button>
      </footer>
    </div>
  </section>
</template>

<script>
import Tag from "@/components/common/Tag";
export default {
  name: "RecommendHospital",
  components: {
    Tag,
  },
  props: {
    orgInfo: {
      type: Object,
    },
  },
  computed: {
    lowestPrice() {
      return (this.orgInfo.lowest_price / 100).toFixed(2);
    },
  },
  data() {
    return {
      channel:sessionStorage.getItem('channel'),
    };
  },
  methods: {
    goToPage() {
      this.$baiDuMtaEvent(["个检/首页", `点击更多机构`, "", "-"]);
      this.$router.push({ path: "package-org-list", query: { type: "org" } });
    },
    goToBooking() {
      this.$baiDuMtaEvent([
        "个检/首页",
        `点击立即预约`,
        this.orgInfo.name,
        "-",
      ]);
      this.$router.push({ path: `org-detail/${this.orgInfo.id}` });
    },
    formatPrice(price) {
      if (price !== 0) {
        return (price / 100).toFixed(2);
      }
      return price;
    },
  },
};
</script>

<style lang="less" scoped>
@import url("~@/assets/css/mixin.less");

.theme-zhongxin {
  .recommend-hospital {
    background: url("~@/assets/images/home/pic_home_jigou_zhongxin_bg@2x.png");
    background-size: cover;
  }
}

.recommend-hospital {
  width: 702/200rem;
  margin: 32/200rem auto 0;
  background: url("~@/assets/images/home/pic_home_jigou_bg@2x.png");
  background-size: cover;
  padding: 30/200rem 0 20/200rem;
  header {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 28/200rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    h3 {
      display: inline-block;
      font-size: 32/200rem;
      line-height: 36/200rem;
    }
    span {
      margin-left: 16/200rem;
      font-size: 22/200rem;
      line-height: 26/200rem;
    }
    .more {
      display: felx;
      align-items: center;
      width: 160/200rem;
      height: 52/200rem;
      background: #ffffff;
      border-radius: 26/200rem 0 0 26/200rem;
      color: @color-theme;
      span {
        margin-left: 24/200rem;
      }
      svg {
        width: 24/200rem;
        height: 24/200rem;
        margin-left: 8/200rem;
      }
    }
  }
  .content {
    width: 662/200rem;
    height: 236/200rem;
    margin: 16/200rem auto 0 auto;
    padding: 30/200rem 30/200rem 28/200rem;
    background: #ffffff;
    border-radius: 12/200rem;
    .name-wrapper {
      display: flex;
      height: 88/200rem;
      .avatar {
        width: 88/200rem;
        height: 88/200rem;
        border-radius: 50%;
        border: 1/200rem solid #d4dee5;
      }
      .name {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 20/200rem;
        font-size: 32/200rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        h3 {
          .ellipsis-line(100% , 1);
        }
      }
    }
    footer {
      display: flex;
      justify-content: space-between;
      margin-top: 34/200rem;
      .price-wrapper {
        display: flex;
        align-items: flex-end;
        font-size: 22/200rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: @color-bg-r;
        line-height: 24/200rem;
        padding-bottom: 10/200rem;
        .price {
          font-size: 40/200rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 32/200rem;
          margin: 0 8/200rem 0 108/200rem;
        }
      }
      .submit {
        width: 162/200rem;
        height: 56/200rem;
        background: @color-theme;
        border-radius: 31/200rem;
        font-size: 22/200rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 56/200rem;
      }
    }
  }
}
</style>
